const SmartphoneIcon = () => (
  <svg width='14' height='23' viewBox='0 0 14 23' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path
      d='M5.25 0.75H3C2.40326 0.75 1.83097 0.987053 1.40901 1.40901C0.987053 1.83097 0.75 2.40326 0.75 3V19.5C0.75 20.0967 0.987053 20.669 1.40901 21.091C1.83097 21.5129 2.40326 21.75 3 21.75H10.5C11.0967 21.75 11.669 21.5129 12.091 21.091C12.5129 20.669 12.75 20.0967 12.75 19.5V3C12.75 2.40326 12.5129 1.83097 12.091 1.40901C11.669 0.987053 11.0967 0.75 10.5 0.75H8.25M5.25 0.75V2.25H8.25V0.75M5.25 0.75H8.25M5.25 19.5H8.25'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default SmartphoneIcon
